<template>
    <a-layout>
        <Header>
            <template slot="head">
                <a-button v-if="mobile" class="drawer-handler"
                    icon="unordered-list" @click="showDrawer" 
                ></a-button>
                <a-drawer v-if="mobile"
                    placement="left"
                    :closable="false" :visible="visible"
                    @close="onClose"
                >
                    <Menu></Menu>
                </a-drawer>
            </template>
        </Header>
        <a-layout>
            <a-layout-sider v-if="!mobile" width="180" class="left-menu" style="background: #fff">
                <Menu></Menu>
            </a-layout-sider>
            <a-layout class="main-brench">
                <a-breadcrumb style="margin: 16px 0">
                    <a-breadcrumb-item>{{ $route.meta.title }}</a-breadcrumb-item>
                </a-breadcrumb>
                <a-layout-content class="main-content"
                    :style="{ background: '#fff', margin: 0, minHeight: '280px' }"
                >
                    <keep-alive>
                        <router-view/>
                    </keep-alive>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import Header from '@/components/Header'
import Menu from './Menu.vue'

const handle = window.matchMedia('(max-width: 600px)');

export default {
    name: 'App',
    data: () => ({
        visible: false,
        mobile: handle.matches,
    }),
    created() {
        handle.onchange = (e) => this.mobile = e.matches;
    },
    methods: {
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
    },
    components: {
        Header, Menu
    },
};
</script>

<style lang="less" scoped>
.drawer-handler {
    margin: 15px;
    margin-left: 0px;
}
@media screen and (min-width: 600px) {
    .main-brench {
        padding: 0 24px 24px
    }
    .main-content {
        padding: 24px
    }
}
@media screen and (max-width: 600px) {
    .main-brench {
        padding: 0
    }
    .main-content {
        padding: 12px
    }
}
</style>